import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import get from 'lodash.get';
import styles from './PositionTypeMissing.css';
import POSITION_TYPES from '../../../constants/position-types';
import RadioButtons from '../Forms/RadioButtons';
import Label from '../Forms/Label';
import FormError from '../Forms/FormError';
import Button from '../Button';
import isCheckedRadio from '../../utils/isCheckedRadio';
import CompanyPositionsMultiSelect from '../CompanyPositionsMultiSelect';

const validateCompanyPositions = (val) => {
    if (val == null || val.length === 0) {
        return 'Please select a position';
    }
    return undefined;
};

const PositionTypeMissing = ({
    positionType,
    submitting,
    pristine,
    handleSubmit,
    error,
}) => (<form onSubmit={handleSubmit}>
    <FormError error={error} />
    <div className={styles.radiosContainer}>
        <Label
            text="Are you a candidate or an employee?"
            name="positionType"
        />
        <Field
            id="candidate-type"
            name="positionType"
            className={styles.radio}
            component={RadioButtons}
            values={[{
                value: POSITION_TYPES.CANDIDATE.toString(),
                label: 'I\'m a Candidate',
            }, {
                value: POSITION_TYPES.EMPLOYEE.toString(),
                label: 'I\'m an Employee',
            }]}
            validate={isCheckedRadio}
        />
    </div>
    <div>
        <Field
            label={Number(positionType) === POSITION_TYPES.EMPLOYEE ? 'Current position' : 'Position applying for...'}
            name="companyPositions"
            positionType={positionType}
            component={CompanyPositionsMultiSelect}
            className={styles.input}
            validate={validateCompanyPositions}
        />
    </div>
    <div className={styles.btnWrap}>
        <Button
            type="submit"
            loading={submitting}
            disabled={pristine}
        >
            Continue
        </Button>
    </div>
</form>);

PositionTypeMissing.propTypes = {
    positionType: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    handleSubmit: PropTypes.func,
    error: PropTypes.any,
};

const formKey = 'missing-position-type';
const selector = formValueSelector(formKey);

export default compose(
    connect(({ form, me }) => ({
        positionType: selector({ form }, 'positionType'),
        initialValues: {
            positionType: get(me, 'positionType', null),
            companyPositions: get(me, 'companyPositions', null),
        },
    })),
    reduxForm({
        form: formKey,
        enableReinitialize: true,
    }),
)(PositionTypeMissing);



// WEBPACK FOOTER //
// ./src/client/Components/PositionTypeMissing/PositionTypeMissingForm.js